import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { OFFICE_ROLES, useAuth, type AppRole } from "@/lib/auth";

function Splash() {
  return (
    <div className="flex min-h-dvh items-center justify-center text-muted-foreground">
      <Loader2 className="size-5 animate-spin" />
    </div>
  );
}

/** Angemeldet und Mandant gewählt — sonst Anmeldung bzw. Mandantenwahl. */
export function RequireSession() {
  const { session, loading, tenant, membershipsLoading } = useAuth();
  const location = useLocation();
  if (loading || (session && membershipsLoading)) return <Splash />;
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!tenant) return <Navigate to="/select-tenant" replace />;
  return <Outlet />;
}

/** Nur angemeldet — für die Mandantenwahl selbst (sonst leitete sie auf sich selbst um). */
export function RequireLogin() {
  const { session, loading, membershipsLoading } = useAuth();
  if (loading || (session && membershipsLoading)) return <Splash />;
  if (!session) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequireRole({ roles, children, fallback = "/me" }: { roles: AppRole[]; children: ReactNode; fallback?: string }) {
  const { hasRole } = useAuth();
  return hasRole(...roles) ? <>{children}</> : <Navigate to={fallback} replace />;
}

/** Startseite je nach Rolle: Verwaltung → /app, alle anderen → Mitarbeiter-App. */
export function HomeRedirect() {
  const { hasRole } = useAuth();
  return <Navigate to={hasRole(...OFFICE_ROLES) ? "/app" : "/me"} replace />;
}
